<template>
  <div style="background:#fff;height:100%"
       id="Article">
    <el-tabs v-model="activeName"
             style="height: 100%;"
             type="border-card"
             @tab-click="handleClick">
      <el-tab-pane label="已发布"
                   style="height: 100%;"
                   name="first">
        <approval configType="all" />
      </el-tab-pane>
      <el-tab-pane label="发布记录"
                   style="height: 100%;"
                   name="second">
        <approval configType="my" />
      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>
import approval from './approval.vue'
import route from '../../route/config'
export default {
  data() {
    return {
      activeName: 'first',
    }
  },
  components: {
    approval,
  },

  methods: {
    handleClick(tab, event) {
      console.log(tab)
    },
  },
  mounted() {
   
  },
  
}
</script>

<style lang="less" >
@import '../../styles/common.less';
.error {
  color: #f56c6c;
  &:focus,
  &:hover {
    color: #f78989;
  }
}
.hovers:hover {
  background-color: #e6efff;
}
* {
  font-size: 15px;
}
.pageBox {
  padding-top: 20px;
  float: right;
}
#pendingOrders {
  .flex {
    background: #fff;
    display: flex;
    height: 100%;
    .sectionfl {
      margin: 10px 20px ;
      background: #fff;
      width: 320px;
      border: 1px solid #dee3ee;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      .content {
        width: 320px;
        color: #666;
        height: 54px;
        line-height: 54px;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
        cursor: pointer;
        font-size: 15px;
      }
      h6 {
        width: 318px;
        background: #f6f8fc;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: normal;
        font-size: 14px;
        // border-bottom: 1px solid #dee3ee;
      }

      .content.active {
        color: #409eff;
      }
    }
    .sectionfr {
       margin-top: 10px;
      flex: 1;
      position: relative;
      overflow-y: auto;
      padding-right: 30px;
      background: #fff;
    }
  }

  h6 {
    color: #606266;
  }
  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  .bg {
    background: #e6efff;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .tip {
    background: #fff7ee;
    padding: 10px;
    color: #eba648;
    font-size: 15px;
  }
}
#Article {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .el-card__body {
    padding: 14px 0px !important;
  }
  .hovers:hover {
    background-color: #e6efff;
  }
  * {
    font-size: 15px;
  }
  .pageBox {
    padding-top: 10px;
    float: right;
    margin-bottom: 10px;
  }
  .sec_card {
    margin-top: 16px;
    height: calc(100vh - 290px);
    overflow-y: scroll;
    .flex {
      background: #fff;
      display: flex;
      height: 650px;
      .sectionfl {
        margin-right: 20px;
        background: #fff;
        width: 320px;
        border: 1px solid #dee3ee;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        .content {
          width: 320px;
          color: #666;
          height: 54px;
          line-height: 54px;
          text-align: center;
          border-bottom: 1px solid #eeeeee;
          cursor: pointer;
          font-size: 15px;
        }
        h6 {
          width: 318px;
          background: #f6f8fc;
          border-top-right-radius: 6px;
          border-top-left-radius: 6px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-weight: normal;
          font-size: 14px;
          border-bottom: 1px solid #dee3ee;
        }

        .content.active {
          color: #409eff;
        }
      }
      .sectionfr {
        flex: 1;
        position: relative;
        overflow-y: auto;
        padding-right: 30px;
        background: #fff;
        .ivu-card-body {
          padding: 0 !important;
        }
      }
    }

    h6 {
      color: #606266;
    }
    ::-webkit-scrollbar {
      /*隐藏滚轮*/
      display: none;
    }
    .bg {
      background: #e6efff;
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }
}
</style>
